import React from "react";
import { Link, NavLink, Route, Routes } from "react-router-dom";
import { RenderRoute } from "../../../utils/router";
import { getLink } from "../../../utils/helpers";
import Motivos from "./Motivos";

const ConfiguracionSalud = () => {
    return <div>
        <div className='page-header'>
            <Link to={getLink('/configuracion')}>&laquo; Volver a configuraciones</Link>
            <h1 className='page-title'>
                Configuración Salud
            </h1>
        </div>

        <div className='row'>
            <div className='col-md-2 page-sidebar'>
                <ul className='list-unstyled page-sidebar__menu'>
                    <li>
                        <NavLink
                            to={getLink(
                                `/configuracion/salud`
                            )}
                            end
                            className='nav-link'>
                            Motivo de Visita
                        </NavLink>
                    </li>
                </ul>
            </div>

            <div className='col-md-10 p-l-40'>
                <Routes>
                    <Route
                        path='/'
                        element={<RenderRoute render={(props) => (
                            <Motivos {...props} />
                        )} />}
                    />
                </Routes>
            </div>
        </div>
    </div>;
};

export default ConfiguracionSalud;